<template>
  <div class="index2">
    <!-- 弹窗 -->
    <div class="popup-overlay" @click="closePopup">
      <div class="popup-content" @click.stop>
        <img
          src="https://ban.iot152.cn/images/guide.png"
          alt="guide"
          class="popup-image"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Index2",
  data() {
    return {
      iccidJump: "",
      showPopup: false,
    };
  },
  // 使用 Vue 2 的 created 或 mounted 获取路由参数
  created() {
    const { abc, iccid, sn } = this.$route.query;
    this.abc = abc; // 若后续需要可使用
    this.iccidJump = iccid || sn;
    if (this.iccidJump) {
      // 修正原逻辑：有设备号时调用接口，不应 return
      this.printingQuery();
    }
    // 如果没有设备号，页面可能保持空白或显示其他内容（可自行扩展）
  },
  methods: {
    printingQuery() {
      const currentUrl = window.location.origin;
      this.$REQ(
        this.$api.printingQuery,
        {
          sn: this.iccidJump,
          url: currentUrl,
        },
        "get"
      )
        .then((res) => {
          // 注意原代码中使用了 res.data.data.url，根据实际接口结构调整
          if (res.data && res.data.data && res.data.data.url) {
            let redirectUrl = res.data.data.url;
            if (res.data.data.key) {
              redirectUrl += res.data.data.key;
            }
            window.location.href = redirectUrl;
          } else {
            this.showPopup = true;
          }
        })
        .catch((err) => {
          console.error("接口请求失败", err);
          this.showPopup = true;
        });
    },
    closePopup() {
      this.showPopup = false;
    },
  },
};
</script>

<style scoped>
.index2 {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  margin: 0;
  padding: 0;
}

.bg-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: auto;
  cursor: pointer;
}

.popup-content {
  position: relative;
  border-radius: 12px;
  max-width: 80%;
  max-height: 80%;
  animation: popupShow 0.3s ease-out;
  cursor: default;
}

.popup-image {
  height: 400px;
  border-radius: 8px;
  display: block;
  max-width: 100%;
  object-fit: contain;
}

/* 弹窗动画 */
@keyframes popupShow {
  from {
    opacity: 0;
    transform: scale(0.8) translateY(-20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
</style>